export const SERVER_URL = 'https://api.reservista.ru'; // for prod
// export const SERVER_URL = 'https://api-devel.reservista.ru';

/* change url in:
*   bash_scripts (2 places)
*   widget/index.js (IFRAME_URL)
*   Reservista-Web/src/constants/integration.js
* */

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
